import React from 'react';
import PropTypes from 'prop-types';
import * as classnames from 'classnames';

export default class Header extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    classNames: PropTypes.string,
    logoSrc: PropTypes.string,
  };

  static defaultProps = {
    title: null,
    subTitle: null,
    classNames: '',
    logoSrc: '/images/edana-logo-dark.svg',
  };

  render() {
    const { title, subTitle, classNames, logoSrc } = this.props;

    return (
      <div className={classnames('text-center', classNames)}>
        <img className="header-logo" height={61} src={logoSrc} width={240} />
        {(title || subTitle) && (
          <h5 className="content-group">
            {title}
            {subTitle && <small className="display-block">{subTitle}</small>}
          </h5>
        )}
      </div>
    );
  }
}
